<template>
    <div class="send-voice-tip">
        开启后，客户可在移动端网页咨询窗口发送短语音消息
        <div class="send-voice-tip-img"></div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="less">
@help-font-color: #a8abb3;

.send-voice-tip {
    width: 260px;

    .send-voice-tip-img {
        background: url('../../assets/change-qq-sendVoice-tip.png') no-repeat;
        background-size: 100%;
        margin-top: 8px;
        width: 260px;
        height: 40px;
    }
}
</style>
